export enum LoginPageEvents {
    ClickedImage = 'Clicked the Image (Login Page)',
    ClickedLogInButton = 'Clicked Log In Button (Login Page)',
    LoggedIn = 'User Logged In',
    ClickedSignUpButton = 'Clicked Sign Up Button (Login Page)',
    ClickedVerifyOTP = 'Clicked Verify OTP',
    SignedUp = 'Signed Up (Login Page)',
}
